import css from "./Tooltip.module.css";
import ReactDOM from "react-dom";

export default function Tooltip({
  isVisible,
  position,
  text,
  centered,
  interactive,
}) {
  if (!isVisible) return null;

  const style = {
    top: `${position?.y}px`,
    left: `${position?.x}px`,
    ...(centered && { transform: "translateX(-50%)" }),
  };

  return ReactDOM.createPortal(
    <div
      className={`${css.tooltip} ${interactive ? css.interactive : ""}`}
      style={style}
      data-interactive-tooltip={interactive ? "" : undefined}
    >
      {text}
    </div>,
    document.body // ⬅️ тултіп рендериться напряму в body
  );
}
